module.exports = __webpack_public_path__ + "img/dots.545c65c8.svg";